import { ModalShell } from "../modals/ModalShell";
import { connectorLabelList } from "./connectorOfferCopy";
import "../Planner/planner.css";
import "./connections.css";

/**
 * Post-wizard hand-off when the athlete chose "import from a training app"
 * but nothing is linked yet. Explains connect → import, then Continues to
 * Dashboard Connections. Shown by `useWizardFinish` for every wizard host.
 */
export function ConnectorPostRaceModal({
  providerLabels,
  raceName,
  onClose,
  onContinue
}: {
  /** Manifest labels currently on offer (empty → generic "training app"). */
  providerLabels: readonly string[];
  raceName?: string | null;
  onClose: () => void;
  /** Go to Dashboard Connections to finish OAuth. */
  onContinue: () => void;
}) {
  const named = providerLabels.map((l) => l.trim()).filter(Boolean);
  const providers =
    named.length === 0 ? "your training app" : connectorLabelList(named);
  // No race name = the no-race (rolling) finish.
  const race = raceName?.trim() || "Your fueling";

  return (
    <ModalShell
      eyebrow="Next step"
      title="Connect your training app"
      onClose={onClose}
      width={480}
      footer={
        <button
          type="button"
          className="fg-btn fg-btn--primary fg-btn--sm"
          data-fg-initial-focus=""
          onClick={onContinue}>
          Continue to Connections
        </button>
      }>
      <div className="fgp-modalshell__pad fgcx-authintro">
        <p>
          {race} is set up. Connect {providers} and we&rsquo;ll import your upcoming
          planned workouts onto your calendar and keep them in sync.
        </p>
        <p>
          You&rsquo;ll pick the app on the next screen, sign in on their site, and
          come straight back here.
        </p>
      </div>
    </ModalShell>
  );
}
